import {Concept} from 'domainTypes';
import type {DataValue, VerifiedLinkedCatalogPostLink} from '../types';
import {isVerifiedLinkedCatalogPostLink} from './isVerifiedLinkedCatalogPostLink';

export const isVerifiedLinkedWorkLink = (
  link: DataValue | undefined,
): link is VerifiedLinkedCatalogPostLink =>
  isVerifiedLinkedCatalogPostLink(link) && link.type === Concept.work;
